import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'sto_index',
      // component: () => import('./views/Sto/index/index.vue' /* webpackChunkName: "index" */),
      component: () => import('./views/Sto/saleRep/index.vue' /* webpackChunkName: "index" */),
    },

    /* --------------------test------------------------------- */
    {
      path: '/saleRep/search',
      component: () => import('./views/Sto/saleRep/search.vue'),
    },
    {
      path: '/saleRep/searchForRep',
      component: () => import('./views/Sto/saleRep/search.vue'),
      meta: {
        params: {
          type: 'repair'
        },
      },
    },
    {
      path: '/saleRep/partSearch/:id',
      component: () => import('./views/Sto/saleRep/part-search.vue'),
    },
    
    {
      path: '/saleRep/scan',
      component: () => import('./views/Sto/saleRep/scan.vue'),
    },

    {
      path: '/saleRep/order/:type/:code',
      component: () => import('./views/Sto/saleRep/workOrder/index.vue'),
    },
    {
      path: '/saleRep/afterSales/:id',
      component: () => import('./views/Sto/saleRep/afterSales/index.vue'),
    },
    {
      path: '/saleRep/submit/:id',
      component: () => import('./views/Sto/saleRep/submit/index.vue'),
    },
    {
      path: '/saleRep/repairSn',
      component: () => import('./views/Sto/saleRep/submit/repair-sn.vue'),
    },
  ],
})
